<template>
  <div class="invite-container">
    <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ede9e7" title="好友邀请" left-arrow @click-left="$router.back()" />
    <!-- Tab Switch -->
    <div class="tab-switch">
      <div 
        :class="['tab-item', { active: activeTab === 'invite' }]"
        @click="activeTab = 'invite'"
      >
        礼金介绍
      </div>
      <div 
        :class="['tab-item', { active: activeTab === 'stats' }]"
        @click="activeTab = 'stats'"
      >
        团队数据
      </div>
    </div>
    
    <!-- Friend Invite View -->
    <div v-if="activeTab === 'invite'" class="invite-view">
      <img 
        :src="lijintu" 
        alt="礼金图片" 
        class="full-image"
      />
    </div>
    <!-- Team Stats View -->
    <div v-if="activeTab === 'stats'" class="unified-card">
      <!-- 代理统计区域 -->
      <div class="stats-section">
        <h2 class="section-title">团队数据</h2>
        <div class="stats-grid">
          <div class="stat-item" v-for="(stat, index) in stats" :key="index">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
      
      <!-- 分隔装饰线 -->
      <div class="divider">
        <div class="divider-line"></div>
        <div class="divider-icon">
          <van-icon name="friends-o" size="20" color="#4facfe" />
        </div>
        <div class="divider-line"></div>
      </div>
      
      <!-- 邀请区域 -->
      <div class="invite-section">
        <h2 class="section-title">邀请好友加入</h2>
        <div class="qrcode-center-section">
          <div class="qrcode-wrapper">
            <qrcode-vue
              :value="qrLink"
              :size="160"
              level="H"
              class="qrcode"
            />
            <div class="qrcode-decoration"></div>
          </div>
        </div>              
        <div class="action-buttons">
          <button @click="downloadQR" class="action-btn download">
            <van-icon name="down" size="16px" />
            保存二维码
          </button>
          <button @click="copyLink" class="action-btn copy">
            <van-icon name="link" size="16px" />
            复制链接
          </button>
        </div>
        
        <div class="invite-link-container">
          <div class="invite-link">{{ qrLink }}</div>
        </div>
        <!-- 图片展示区域 -->
        <div class="invite-image-clickable" @click="previewImage">
          <img :src="fenxiangtu" alt="邀请图片" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import { Icon,ImagePreview  } from 'vant'

export default {
  name: 'InvitePage',
  components: {
    QrcodeVue,
    [Icon.name]: Icon
  },
  data() {
    return {
      qrLink: '',
	  lijintu: '',
      stats: [],
      activeTab: 'invite' // 'invite' or 'stats'
    }
  },
  mounted() {
    this.qrLink = `${window.location.origin}/#/register?type=1&pid=${this.$store.state.userInfo.user_id}`;
    this.fetchStats()
	this.getBanner()
  },
  methods: {  
    previewImage() {
      ImagePreview({
        images: [this.fenxiangtu],
        startPosition: 0,
        closeable: true,
        showIndex: false,
      });
    },  
    fetchStats() {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.get('/api/stats', {}).then(res => {
        that.$parent.hideLoading();
        if(res) {
          const data = res;
          that.$set(that, 'stats', [
            { label: '下级成员', value: data.total_downlines || 0 },
            { label: '本月注册', value: data.month_new_downlines || 0 },
            { label: '本月活跃', value: data.month_active_downlines || 0 },
            { label: '有效成员', value: data.month_valid_users || 0 },
            { label: '今日新增', value: data.today_new_downlines || 0 },
            { label: '今日活跃', value: data.today_active_downlines || 0 },
            { label: '本月存款', value: `¥${data.month_downline_deposit || 0}` },
            { label: '今日存款', value: `¥${data.today_downline_deposit || 0}` }
          ]);
        } else {
          console.log('res不存在或为空');
        }
      }).catch(() => {
        that.$parent.hideLoading();
        that.$toast.fail('请求接口失败');
      });
    },	
    getBanner() {
      this.$parent.showLoading();
      this.$apiFun.post('/api/bannerList', { type: 3 }).then(res => {
        if(res.code === 200 && res.data) {
          this.bannerList = res.data; 
          if(this.bannerList.length > 0) {
            this.lijintu = this.bannerList[0].src;
			this.fenxiangtu = this.bannerList[1].src; 
          }
        } else {
          this.bannerList = [];
          console.log('没有获取到 banner 数据');
        }
      }).finally(() => {
        this.$parent.hideLoading();
      });
    },  	  
    copyLink() {
      navigator.clipboard.writeText(this.qrLink).then(() => {
        this.$toast.success('链接已复制');
      }).catch(() => {
        const textarea = document.createElement('textarea');
        textarea.value = this.qrLink;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.$toast.success('链接已复制');
      });
    },
    downloadQR() {
      const canvas = document.querySelector('.qrcode canvas');
      if (!canvas) return this.$toast.fail('二维码未渲染');
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = '邀请二维码.png';
      link.click();
      this.$toast.success('二维码已保存');
    }
  }
}
</script>

<style scoped>
/* 基础样式 */
.invite-container {
  min-height: 100vh;
  padding: 10px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  display: flex;
  flex-direction: column;
}

/* Tab Switch */
.tab-switch {
  display: flex;
  margin: 10px 15px 15px;
  background: #f0f7ff;
  border-radius: 20px;
  padding: 4px;
  position: relative;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #4facfe;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1;
  border-radius: 16px;
}

.tab-item.active {
  background: linear-gradient(to right, #4facfe, #00f2fe);
  color: white;
  box-shadow: 0 4px 10px rgba(79, 172, 254, 0.3);
}

/* Full Image View */
.invite-view {
  margin-top: 10px;
}

.full-image {
  width: 100%;
  border-radius: 10px;
  display: block;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

/* 统一卡片容器 */
.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding-bottom: 20px;
}

/* 公共标题样式 */
.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 10px 0 15px;
  position: relative;
  padding-bottom: 10px;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #4facfe, #00f2fe);
  border-radius: 3px;
}

/* 统计区域样式 */
.stats-section {
  padding: 0 15px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 改为6列 */
  gap: 2px;
  margin-top: 10px;
}

.stat-item {
  grid-column: span 2;
}

.stat-item:nth-last-child(-n+2) {
  grid-column: span 3;
}
.stat-item {
  background: #f9fbfd;
  border-radius: 10px;
  padding: 14px 8px;
  text-align: center;
  border: 1px solid #eef2f6;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(79, 172, 254, 0.1);
}

.stat-value {
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 12px;
  color: #7f8c8d;
  margin-bottom: 4px;
}

.stat-trend {
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 分隔线样式 */
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0;
  padding: 0 30px;
}

.divider-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, transparent, #e0e6ed, transparent);
}

.divider-icon {
  margin: 0 15px;
  background: #f5f9ff;
  padding: 5px;
  border-radius: 50%;
  border: 1px solid #e0e6ed;
}

/* 邀请区域样式 */
.invite-section {
  padding: 0 20px;
  background-image: url('/static/image/87b27a56cbdf471d95c953d306ff1972.gif');
  background-position: 35% 10%;  
}
.qrcode-center-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 10px 0;
  margin: 10px 0;
}
.qrcode-wrapper {
  position: relative;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
}

.qrcode-decoration {
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border: 1px dashed rgba(79, 172, 254, 0.3);
  border-radius: 16px;
  pointer-events: none;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 20px 0;
}

.action-btn {
  padding: 10px 18px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.action-btn.download {
  background: linear-gradient(to right, #4facfe, #00f2fe);
  color: white;
  box-shadow: 0 4px 10px rgba(79, 172, 254, 0.3);
}

.action-btn.copy {
  background: #f0f7ff;
  color: #4facfe;
  border: 1px solid #d0e5ff;
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
}

.invite-link-container {
  background: #f8fafc;
  border-radius: 10px;
  padding: 12px;
  margin-top: 15px;
}

.invite-link {
  font-size: 12px;
  color: #4a5568;
  word-break: break-all;
  text-align: center;
  line-height: 1.4;
}
.invite-image-clickable {
  margin: 15px 0 0;
}

.invite-image-clickable img {
  width: 100%;
  border-radius: 10px;
  display: block;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.invite-image-clickable img:hover {
  transform: scale(1.01);
}
</style>


// WEBPACK FOOTER //
// src/components/main/yaoqing.vue